export default __webpack_public_path__ + "images/552b1f6f729af3e8260ecf00593bc7b8-gacr-en_rgb.png";